/** True for objects and arrays, the values that must not be printed with String() ("[object Object]"). */
export function isStructured(value: unknown): boolean {
  return typeof value === 'object' && value !== null;
}

/** Readable text of one value of a log's context: objects and arrays as indented JSON, the rest as plain text. */
export function formatLogValue(value: unknown): string {
  if (value === undefined) return '';
  if (isStructured(value)) return JSON.stringify(value, null, 2);
  return String(value);
}
